import React from 'react';
import { Calculator, Search, Upload } from 'lucide-react';

const Navigation = ({ activeView, setActiveView }) => {
  return (
    <nav className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <h1 className="text-xl font-bold text-gray-900">Lead Scoring System</h1>

          <div className="flex gap-4">
            <button
              onClick={() => setActiveView('calculator')}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors ${
                activeView === 'calculator'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <Calculator className="w-4 h-4" />
              Score Calculator
            </button>

            <button
              onClick={() => setActiveView('search')}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors ${
                activeView === 'search'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <Search className="w-4 h-4" />
              Search Leads
            </button>

            <button
              onClick={() => setActiveView('upload')}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors ${
                activeView === 'upload'
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <Upload className="w-4 h-4" />
              Document Analysis
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;